import React from "react";
import {connect} from "react-redux";

const LiveChatWidget = ({user, hide}) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = "https://chat.priorityprospect.com/packs/js/sdk.js";

    document.getElementsByTagName("head")[0].appendChild(script);

    setTimeout(() => {
        window.chatwootSDK.run({
            websiteToken: 'wDX7qsugGLscFVxPCEVxBQZj',
            baseUrl: 'https://chat.priorityprospect.com',
        })
    }, 1000)

    window.addEventListener("chatwoot:ready", function () {
        window.chatwootSettings = {
            hideMessageBubble: false,
            showUnreadMessagesDialog: true,
            position: "left",
            locale: "en",
            useBrowserLanguage: false,
            type: "standard",
            darkMode: "auto",
        };

        if(hide) {
            window.$chatwoot.toggleBubbleVisibility("hide");
        }

        let hasAccountManager = false;
        let accountManagerEmail = null;

        if(typeof(user.user.company.account_manager) !== 'undefined') {
            hasAccountManager = true;
            accountManagerEmail = user.user.company.account_manager.email;
        }

        let attributes = {
            'company': user.user.company.name,
            'company_id': user.user.company.guid,
        }

        if(hasAccountManager) {
            attributes['account_manager'] = accountManagerEmail;
        }

        window.$chatwoot.setCustomAttributes(attributes);

        window.$chatwoot.setUser(user.user.company.guid, {
            email: user.user.email,
            name: user.user.first_name + " " + user.user.last_name
        });
    });

    return <></>;
}

const SupportTicketWidget = () => {
    const script = document.createElement('script');
    script.async = true;
    script.src = "https://support.priorityprospect.com/addons/Channels/HelpWidget/Views/js/supportpal.min.js?v=5.4.0";

    document.getElementsByTagName("head")[0].appendChild(script);

    window.supportpalAsyncInit = function () {
        window.SupportPal.mount({
            "baseURL": "https://support.priorityprospect.com/en/helpwidget",
            "hash": "xiQfZYoMDR",
            "type": "popup",
            "position": "left",
            "colour": "#0f2463",
            "buttonIcon": "lifebuoy",
            "knowledgebase": {
                "enabled": true,
                "typeId": "2"
            },
            "submitTicket": {
                "enabled": true,
                "departmentId": "5",
                "subject": true
            }
        });
    };

    return <></>
}

class LiveChat extends React.Component {
    render() {
        /*if(this.props.wizard.showWizard) {
            return <LiveChatWidget user={this.props.user} hide={true} />
        }*/

        if(typeof(this.props.user.user.company.account_manager) !== 'undefined') {
            return <LiveChatWidget user={this.props.user} hide={false} />
        }

        if(this.props.user.user.company.is_partner) {
            return <LiveChatWidget user={this.props.user} hide={false} />
        }


        if(this.props.user.user.company.ip_address_count === 0) {
            return <LiveChatWidget user={this.props.user} hide={false} />
        }

        setTimeout(() => {
            /*if(!this.props.wizard.showWizard && !this.props.wizard.isMinimized && typeof(this.props.user.user.company.account_manager) === 'undefined' && !this.props.user.user.company.is_partner) {
                SupportTicketWidget();
            }*/
            if(typeof(this.props.user.user.company.account_manager) === 'undefined' && !this.props.user.user.company.is_partner) {
                SupportTicketWidget();
            }
        }, 2000);

        return <></>;
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
    wizard: state.getting_started_wizard,
});

export default connect(mapStateToProps, {})(LiveChat);